import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData } from "./actions";
import { type MemberAffiliate } from "./types";

const reducer = (
  state: MemberAffiliate.AppState = defaultState,
  action: ReduxAction<any>
): MemberAffiliate.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { offers } = action.data as InitSuccessActionData;
      return {
        ...state,
        offers,
        status: Status.Ready
      };
    }
    default:
      return state;
  }
};

export const defaultState: MemberAffiliate.AppState = {
  error: null,
  id: "",
  status: Status.None,
  offers: []
};
export const previewState: MemberAffiliate.AppState = {
  ...defaultState,
  status: Status.Ready,
  offers: [{ description: "Dummy", id: "", name: "Dummy", pages: [] }]
};
export default wrapReducer({ defaultState, reducer, previewState });
